import { Environment } from '@/enums'

/**
 * Prototype preview pages (Branches, MRs, Catalog, …) — **local only**.
 *
 * Enabled only in Vite DEV when either:
 * - `VITE_DEV_ENV=docker` (local backend), or
 * - `VITE_PREVIEW_PAGES_ENABLED=true` (explicit opt-in in `.env.local`)
 *
 * Not enabled when `VITE_DEV_ENV=dev` (remote metacroc-dev), and never in
 * production builds (`import.meta.env.DEV` is false).
 */
export const IS_PREVIEW_PAGES_ENABLED =
	import.meta.env.DEV &&
	(import.meta.env.VITE_DEV_ENV === Environment.Docker ||
		import.meta.env.VITE_PREVIEW_PAGES_ENABLED === 'true')

/**
 * AI Agents preview page — code stays in the tree; chrome + route stay off
 * until this is flipped (still requires {@link IS_PREVIEW_PAGES_ENABLED}).
 */
export const IS_AI_AGENTS_PREVIEW_ENABLED = false
